import requests from '@/utils/request.js'

export const getHomeInitDataAPI = () => requests({
  method:'POST',
  url:'/api/user/data/initdata',
})
export const getnoread = () => requests({
  method:'POST',
  url:'/api/user/data/get_no_read',
})
export const Cliernoread = () => requests({
  method:'POST',
  url:'/api/user/data/set_read',
})